import React from "react";
import "../styles/Contact.css";

const Contact = () => {
    return (
        <>
            <section className="contact-wrap" id="contact">
                <div className="contact-container">

                    {/* LEFT SIDE */}
                    <div className="left">
                        <h2>CONTACT DETAILS</h2>

                        <p>OFFICE ADDRESS: <span className="line"></span></p>
                        <p>PHONE NUMBER: <span className="line"></span></p>
                        <p>EMAIL ID: <span className="line"></span></p>

                        <div className="social-block">
                            <p>SOCIAL MEDIA:</p>
                            <p>• FACEBOOK: <span className="line"></span></p>
                            <p>• TWITTER (X): <span className="line"></span></p>
                            <p>• INSTAGRAM: <span className="line"></span></p>
                            <p>• WHATSAPP CONTACT (IF AVAILABLE): <span className="line"></span></p>
                        </div>
                    </div>

                    {/* RIGHT SIDE */}
                    <div className="right">
                        <h2>JOIN OUR NEWSLETTER</h2>

                        <p className="desc">
                            IS SIMPLY DUMMY TEXT OF THE PRINTING AND TYPESETTING INDUSTRY.
                            LOREM IPSUM HAS BEEN THE INDUSTRY'S STANDARD DUMMY TEXT EVER
                        </p>

                        <input type="email" placeholder="EMAIL ADDRESS" />
                        <button>SUMBIT</button>
                    </div>

                </div>


            </section>
            {/* FOOTER STRIP */}
            <div className="leader">
                <div className="icons">
                    <span className="fb">f</span>
                    <span className="ig">📸</span>
                    <span className="x">𝕏</span>
                </div>
                <div className="leadersub">
                    <img src="/assets/tvkimages/corner.png" alt="leader" />
                    <img className="branimagename" src="/assets/tvkimages/brandname.png" alt="" />
                </div>
            </div>
            <div className="footer-strip1"></div>
            <div className="footer-strip2"></div>
        </>
    );
};

export default Contact;
